import React, { useMemo, useState } from 'react'

import { useDebounce } from 'hooks/useDebounce'
import { Catalog, CatalogFilterOption } from 'api/actions/catalogs/catalogsActions.types'

import { ResourcesContext } from './ResourcesContext'
import { ResourcesContextControllerProps } from './ResourcesContextController.types'

export const ResourcesContextController = ({ children }: ResourcesContextControllerProps) => {
    const [searchValue, setSearchValue] = useState('')
    const [selectedResourceTypes, setSelectedResourceTypes] = useState<CatalogFilterOption[]>([])
    const [selectedKpis, setSelectedKpis] = useState<CatalogFilterOption[]>([])
    const [selectedResource, setSelectedResource] = useState<Catalog | null>(null)
    const debouncedSearchValue = useDebounce(searchValue, 500)

    const handleChangeSearchValue = (searchValue: string) => {
        setSearchValue(searchValue)
    }

    const handleChangeSelectedResourceTypes = (selectedResourceTypes: CatalogFilterOption[]) => {
        setSelectedResourceTypes(selectedResourceTypes)
    }

    const handleChangeSelectedKpis = (selectedKpis: CatalogFilterOption[]) => {
        setSelectedKpis(selectedKpis)
    }

    const handleChangeSelectedResource = (resource: Catalog | null) => {
        setSelectedResource(resource)
    }

    const contextValue = useMemo(
        () => ({
            searchValue,
            debouncedSearchValue: debouncedSearchValue,
            onChangeSearchValue: handleChangeSearchValue,
            selectedResourceTypes,
            onChangeSelectedResourceTypes: handleChangeSelectedResourceTypes,
            selectedKpis,
            onChangeSelectedKpis: handleChangeSelectedKpis,
            selectedResource,
            onChangeSelectedResource: handleChangeSelectedResource,
        }),
        [debouncedSearchValue, searchValue, selectedKpis, selectedResource, selectedResourceTypes],
    )

    return <ResourcesContext.Provider value={contextValue}>{children}</ResourcesContext.Provider>
}
